import '../../public/css/appcenter.less';
import '../../public/css/components/AppCenter/LoggedOutHeaderFooter.less';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { recordClick, recordImpression } from '@paypalcorp/fpti-tracker';
import { getTools } from '../lib/containers';
import { clientLogger } from '../lib/logger';
import {
  getRankJsonString,
  buildMainAggRankJsonString,
  buildCategoryAggRankJsonString
} from '../lib/fptiRecommendationHelper';
import AppCenter from '../components/AppCenter';
import dataFetcher from './DataFetcher';
import filterPSData from '../lib/filterPSData';
import * as MyAppsActions from '../actions/myapps';
import * as AppCenterActions from '../actions/appcenter';
import * as AppActions from '../actions/app';
import * as TrackingActions from '../actions/tracking';
import { getUtmParams } from '../lib/helpers';

import { AMPLITUDE } from '../lib/constants';

const {
  AMPLITUDE_PRODUCT,
  AMPLITUDE_EVENT_PROPS,
  MAIN_IMPRESSION,
  CATEGORY_IMPRESSION,
  DETAIL_IMPRESSION
} = AMPLITUDE;

const mapStateToProps = (state, props = {}) => {
  const newPSData = get(state, 'appcenter.psData', {});
  const tools = getTools(state);
  const country = get(state, 'app.context.locale.country', '');
  const isLoggedIn = get(state, 'app.fptiData.lgin');
  const experimentation = get(state, 'experimentation');
  const merchantActivationState = get(
    state,
    'appcenter.merchantActivationState'
  );
  const productIntentTools = get(state, 'appcenter.productIntentTools', {});
  const quicklinks = {
    ...get(state, 'quicklinks', {}),
    appData: get(newPSData, 'details.DetailsHeader', {}),
    context: {
      csrf: get(state, 'app.csrf'),
      language: get(state, 'app.context.locale.language')
    }
  };
  const args = {
    psData: newPSData,
    mtsData: tools,
    country,
    isLoggedIn,
    experimentation,
    productIntentTools,
    merchantActivationState
  };

  const { flatData, structuredData } = filterPSData(args);

  const pathname = props.location?.pathname || '';
  const comp = 'merchanthubnodeweb';
  let pgrp = 'main:merchanthub:appcenter';

  const [, , categorySlug, detailsSlug] = pathname.split('/');

  // create the pgrp value
  let tool;
  let category;
  if (detailsSlug) {
    tool = Object.values(flatData.tools).find(
      ({ location }) => location === detailsSlug
    );
    if (!tool) {
      clientLogger.warn('Tool not found for the detail slug', detailsSlug);
    } else {
      pgrp += `:${tool.appFPTI}`;
    }
  } else if (categorySlug) {
    category = Object.values(flatData.categories).find(
      ({ location }) => location === categorySlug
    );

    if (!category) {
      clientLogger.warn(
        'Category not found for the category slug',
        categorySlug
      );
    } else {
      pgrp += `:${category.categoryFPTI}`;
    }
  } else {
    pgrp += `:main`;
  }

  // not server code . . .
  if (typeof window !== 'undefined') {
    // important for feedback fragment and ErrorBoundary, which needs access to global fpti data
    window.feedback = {
      pgrp,
      page: pgrp
    };

    if (tool) {
      window.feedback.prod = tool.appFPTI;
    }
  }

  const fptiClick = (options = {}) => {
    const { fptiLink = '', pageLink = '' } = options;
    const container = {
      // add a colon only if link has length
      page: `${pgrp}${pageLink && !pgrp.match(pageLink) ? ':' + pageLink : ''}`,
      pgrp
    };

    const optionsObj = {
      custId: get(state, 'app.custId'),
      acct_cntry: get(state, 'app.legalCountry'),
      link: fptiLink,
      comp
    };

    // every click on product detail pages gets prod: <product> field
    if (tool) {
      optionsObj.prod = tool.appFPTI;
      // Add rank object to CTA click event
      optionsObj.rank = getRankJsonString(tool);
    }

    // categoryToolTile click event
    if (options.categoryRank) {
      // Add rank object to Tool Tile click event
      // This comes from Main Page Category/RFY rows and Category Page sections or tools
      optionsObj.rank = getRankJsonString(options);
    }

    if (options.prod) {
      optionsObj.prod = options.prod;
    }

    if (options.category) {
      optionsObj.category = options.category;
    }

    if (options.type) {
      optionsObj.type = options.type;
    }

    if (options.utm_source) {
      optionsObj.utm_source = options.utm_source;
    }

    if (options.utm_medium) {
      optionsObj.utm_medium = options.utm_medium;
    }

    if (options.utm_content) {
      optionsObj.utm_content = options.utm_content;
    }

    if (options.utm_campaign) {
      optionsObj.utm_campaign = options.utm_campaign;
    }
    // add partner_name for all partner prod clicks on main and category pages
    if (pageLink === 'partners') {
      if (options.prod) {
        // add partner_name
        optionsObj.partner_name = options.prod;
      }
    }

    // IF this is a details page for a partner . . .
    if (tool && pathname.includes('partners')) {
      // add partner_name
      optionsObj.partner_name = tool.appFPTI;
    }

    //search options for app search in header
    if (pageLink.includes('search')) {
      optionsObj.srch = options.srch || '';
      optionsObj.result = options.result || '';
      if (!container.page.includes('search')) {
        container.page = `${container.page}:search`;
      }
      if (!container.pgrp.includes('search')) {
        container.pgrp = `${container.pgrp}:search`;
      }
    }

    if (options.amplitude) {
      let app_category = '';
      // get app_category
      if (category) {
        app_category = category?.categoryKey || '';
      } else if (fptiLink === 'viewall') {
        // CategoryCard click
        app_category = pageLink;
      } else if (fptiLink === 'get_started') {
        app_category = tool?.categoryKey || '';
      } else if (options.category === 'parent') {
        // BreadCrumbs category click
        app_category = fptiLink;
      }

      if (options.link === 'main' || fptiLink === 'main') {
        // click on 'App Center'/ main breadcrumb
        // special case -> no app_category
        app_category = '';
      }

      optionsObj.product = AMPLITUDE_PRODUCT;
      optionsObj.event_name = options.event_name;
      optionsObj.event_props = AMPLITUDE_EVENT_PROPS;
      optionsObj.app_category = app_category;
      optionsObj.referrer = document?.referrer || '';
    }

    recordClick(optionsObj, container);
  };

  const fptiImpression = (options = {}) => {
    const { pageLink = '' } = options;
    const container = {
      // add a colon only if link has length
      // add link only if it is not in pgrp (this happens on category page for products)
      page: `${pgrp}${pageLink && !pgrp.match(pageLink) ? ':' + pageLink : ''}`,
      pgrp
    };

    const optionsObj = {
      custId: get(state, 'app.custId'),
      comp,
      acct_cntry: get(state, 'app.legalCountry')
    };

    // add prod to the page impression for details
    if (tool) {
      optionsObj.prod = tool.appFPTI;
      // Add rank object to detail page impression
      optionsObj.rank = getRankJsonString(tool);
    }

    if (options.categoryRank) {
      // Add rank object to Tool Tile impression event
      // This comes from Main Page Category/RFY rows and Category Page sections or tools
      optionsObj.rank = getRankJsonString(options);
    }

    if (options.category) {
      optionsObj.category = options.category;
    }

    // add aggregated rank object to Main Page impression
    if (!options.pageLink && !categorySlug && !detailsSlug) {
      optionsObj.rank = buildMainAggRankJsonString(
        flatData.defaultRecommended,
        structuredData
      );
    }
    // add aggregated rank object to a Category Page impression event
    if (!options.pageLink && category && categorySlug && !detailsSlug) {
      optionsObj.rank = buildCategoryAggRankJsonString(
        category,
        structuredData
      );
    }

    if (options.prod) {
      optionsObj.prod = options.prod;
    }

    // if passed pageLink is 'partners'
    if (pageLink === 'partners') {
      // categories and sections don't have prod . . .
      // IF prod is passed, it is a tool tile in partners
      if (options.prod) {
        // add partner_name
        optionsObj.partner_name = options.prod;
      }
    }

    // if and only if we navigate to a '/partners' details page
    if (detailsSlug && tool && pathname.includes('/partners')) {
      // add partner_name
      optionsObj.partner_name = tool.appFPTI;
    }

    if (options.erpg) {
      optionsObj.erpg = options.erpg;
      optionsObj.eccd = options.eccd || 'code'; // code signifies code error
    }

    if (options.type) {
      optionsObj.type = options.type;
    }

    if (options.utm_source) {
      optionsObj.utm_source = options.utm_source;
    }

    if (options.utm_medium) {
      optionsObj.utm_medium = options.utm_medium;
    }

    if (options.utm_content) {
      optionsObj.utm_content = options.utm_content;
    }

    if (options.utm_campaign) {
      optionsObj.utm_campaign = options.utm_campaign;
    }

    if (options.amplitude) {
      optionsObj.product = AMPLITUDE_PRODUCT;

      let event_name;
      if (tool) {
        event_name = DETAIL_IMPRESSION;
      } else if (category) {
        event_name = CATEGORY_IMPRESSION;
      } else {
        event_name = MAIN_IMPRESSION;
      }
      optionsObj.event_name = event_name;

      optionsObj.event_props = AMPLITUDE_EVENT_PROPS;
      optionsObj.app_category =
        category?.categoryKey || tool?.categoryKey || '';
      optionsObj.referrer = document?.referrer || '';
    }

    recordImpression({ ...optionsObj, ...getUtmParams() }, container);
  };

  return {
    app: get(state, 'app', {}),
    fptiClick,
    fptiImpression,
    seo: newPSData.seo,
    detailsContent: get(state, 'appcenter.detailsContent'),
    tools: tools,
    toolServFavorites: get(state, 'myapps.favorites', []),
    flatPSData: flatData,
    structuredPSData: structuredData,
    quicklinks: quicklinks,
    search: get(state, 'myapps.search', {}),
    appSearch: get(state, 'appcenter.appSearch', {}),
    experimentation
  };
};

const mapDispatchToProps = dispatch => ({
  ...AppCenterActions,
  ...MyAppsActions,
  ...AppActions,
  ...TrackingActions,
  dispatch
});

const Wrapper = dataFetcher(AppCenter, [MyAppsActions.fetchTools]);
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
